<template>
    <div class="about">
        <div class="company">
            <div class="cube"></div>
            <div class="us">
                <div class="title"></div>
                <div class="cont">
                    <!-- <p>
                        小盒是中国知名的教育科技公司，秉持“以学习者为中心”的教育理念，致力于用技术实现家校的连接、打通、闭环，构建基于校内教学和家庭辅导的智能教育服务生态。</p>
                        <p>小盒旗下有目前国内最大的面向公立学校师生应用的教学工具之一“小盒老师”和“小盒学生”App，以及为学生提供贴近校内教学的自适应学习辅导服务品牌“小盒课堂”。</p>
                        <p>截止目前，小盒的产品已经走进了全国
                        <span class="highlight">31</span>个省市自治区近
                        <span class="highlight">400</span>座城市的
                        <span class="highlight">10万</span>所学校，有超过
                        <span class="highlight">1亿</span>小学师生家长在使用小盒提供的工具、课程和教学辅导服务。
                    </p> -->
                    <!-- <p class="gap"></p> -->
                    <!-- <p>未来，小盒将秉承“教得更好，学得更好”的使命，继续推动大数据、Al、深度学习等技术在教育领域的应用，推动优质教育的普惠、均衡，让每个孩子都有自己的智慧老师，让每个老师都有自己的智慧助教！</p> -->
                    <p>小盒课堂是经教育主管部门批准的学科类在线培训服务品牌，面向全国中小学生提供数学、语文、英语等科目在线课程和学习辅导服务。</p>
                    <p>小盒课堂始终秉承“以学习者为中心”的教育理念，始终坚持“做学校教育的有益补充”的定位，为用户提供巩固校内、查缺补漏、拓展思维的课程产品和服务，努力做好“孩子的第二课堂”。</p>
                </div>
            </div>
        </div>
        <!-- <div class="history">
            <div class="main-title">History</div>
            <div class="list">
                <div class="swiper-wrapper">
                    <swiper :options="swiperOption" ref="swiper" class="swiper">
                        <swiper-slide
                            :class="'swiper__slide slide-' + index"
                            v-for="(item, index) in timeLineData"
                            :key="index"
                            :style="{'background': 'url(' + item + ') center center no-repeat'}"
                        ></swiper-slide>
                    </swiper>
                    <div class="btns">
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="team">
            <div class="title">Team</div>
            <div class="list">
                <div class="people1">
                    <div class="photo"></div>
                    <div class="rank">CEO</div>
                    <div class="profile">
                        <div class="name">贾晓明</div>
                        <div class="intro">
                            <p>前科利华副总裁，</p>
                            <p>前英特尔教育中国区负责人。</p>
                        </div>
                    </div>
                </div>
                <div class="people2">
                    <div class="photo"></div>
                    <div class="rank">COO</div>
                    <div class="profile">
                        <div class="name">王克</div>
                        <div class="intro">
                            <p>前英特尔本土OEM行业销售负责人，</p>
                            <p>前百度战略合作部总经理</p>
                        </div>
                    </div>
                </div>
                <div class="people3">
                    <div class="photo"></div>
                    <div class="rank">CMO</div>
                    <div class="profile">
                        <div class="name">张民健</div>
                        <div class="intro">
                            <p>前美团点评到店业务总经理。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
// require styles
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

const YOUPAI = "https://appd.knowbox.cn/ss/activity/knowbox-web/img/";

@Component({
    components: {
        swiper,
        swiperSlide
    }
})
export default class About extends Vue {
    // private swiperOption: any = {
    //     slidesPerView: 1,
    //     navigation: {
    //         nextEl: ".swiper-button-next",
    //         prevEl: ".swiper-button-prev"
    //     }
    // };
    // private timeLineData: any = [
    //     `${YOUPAI}about/timeline-1@x2.png`,
    //     `${YOUPAI}about/timeline-2@x2.png`,
    //     `${YOUPAI}about/timeline-3@x2.png`,
    //     `${YOUPAI}about/timeline-4@x2.png`,
    //     `${YOUPAI}about/timeline-5@x2.png`,
    //     `${YOUPAI}about/timeline-6@x2.png`,
    //     `${YOUPAI}about/timeline-7@x2.png`,
    //     `${YOUPAI}about/timeline-8@x2.png`
    // ];

    get swiper() {
        return this.$refs.swiper.swiper;
    }
}
</script>
<style lang="scss">
.about {
    padding-top: 188px;
    box-sizing: border-box;
    .company {
        width: 1074px;
        margin: 0 auto;
        overflow: hidden;
        .cube {
            width: 230px;
            height: 230px;
            background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/about/cubex2.png)
                no-repeat;
            background-size: 100% 100%;
            float: left;
        }
        .us {
            padding-left: 264px;
            box-sizing: border-box;
            font-size: 16px;
            color: #333335;
            font-weight: 500;
            .title {
                width: 262px;
                height: 86px;
                // background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/about/about-usx2.jpg)
                    // no-repeat;
                background: url('https://susuanqiniu.knowbox.cn/fe/www-m/about-us.png')  no-repeat;  
                background-size: 100% 100%;
            }
            .cont {
                margin-top: 66px;
                line-height: 32px;
                font-family: PingFangSC-light;
                .light {
                    color: #fa5000;
                }
                .highlight {
                    font-size: 32px;
                    color: #fa5000;
                    font-family: arial-black;
                }
                .gap {
                    height: 30px;
                }
                &>p{
                    text-indent: 2em;
                }
            }
        }
    }
    // .history {
    //     width: 100%;
    //     background: #fb5000;
    //     margin-top: 110px;
    //     padding: 48px 0 195px;
    //     .main-title {
    //         width: 213px;
    //         height: 94px;
    //         background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/about/historyx2.png)
    //             no-repeat;
    //         background-size: 100% 100%;
    //         text-indent: -99999px;
    //         margin: 0 auto;
    //     }
    //     .swiper {
    //         width: 100%;
    //         user-select: none;
    //         &__slide {
    //             height: 380px;
    //             background-size: cover !important;
    //         }
    //     }
    //     .btns {
    //         position: absolute;
    //         left: 50%;
    //         transform: translate(-50%);
    //         bottom: -102px;
    //         .swiper-button-prev,
    //         .swiper-button-next {
    //             left: -100px;
    //             width: 118px;
    //             height: 118px;
    //             background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/about/prev.png)
    //                 no-repeat;
    //             outline: 0;
    //             cursor: pointer;
    //         }
    //         .swiper-button-next {
    //             left: 0;
    //             background-image: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/about/next.png);
    //         }
    //     }
    // }
    .team {
        width: 1200px;
        padding-bottom: 112px;
        box-sizing: border-box;
        margin: 0 auto;
        .title {
            width: 223px;
            height: 122px;
            background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/about/Teamx2.png)
                no-repeat;
            background-size: 100% 100%;
            text-indent: -99999px;
            margin: 84px auto 65px;
        }
        .list {
            color: #3c3c3e;
            display: flex;
            justify-content: space-between;
            .rank {
                font-size: 18px;
                margin: 25px 0 15px;
                // font-family: PingFangSC-light;
            }
            .name {
                margin-bottom: 15px;
                color: #3c3c3e;
            }
            .intro {
                font-size: 14px;
                line-height: 25px;
                font-family: PingFangSC-light;
            }
            .people3 {
                cursor: pointer;
                text-align: center;
                .photo {
                    width: 372px;
                    height: 271px;
                    background: url(https://susuanqiniu.knowbox.cn/minjian.png)
                        no-repeat;
                    background-position: 40px;
                    background-size: auto 100%;
                }
                &:hover {
                    .photo {
                        background-image: url(https://susuanqiniu.knowbox.cn/minjian1.png);
                        background-position: 0;
                    }
                    .name {
                        color: #ef5d17;
                    }
                }
            }
            .profile {
                .name {
                    font-size: 24px;
                    font-family: PingFangSC-Medium;
                }
            }
            .people2 {
                cursor: pointer;
                text-align: center;
                .photo {
                    width: 372px;
                    height: 264px;
                    background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/about/wangke.png)
                        no-repeat;
                    background-position: 39px 0;
                    background-size: auto 100%;
                }
                &:hover {
                    .photo {
                        background-image: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/about/wangke-light.png);
                        background-position: 0 0;
                    }
                    .name {
                        color: #ef5d17;
                    }
                }
            }
            .people1 {
                cursor: pointer;
                text-align: center;
                .photo {
                    width: 329px;
                    height: 270px;
                    background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/about/jiaxiaoming.png)
                        no-repeat;
                    background-position: 40px;
                    background-size: auto 100%;
                }
                &:hover {
                    .photo {
                        background-image: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/about/jiaxiaoming-light.png);
                        background-position: 0;
                    }
                    .name {
                        color: #ef5d17;
                    }
                }
            }
        }
    }
}
</style>